import currentUser from "./currentUser";
import roles from "./roles";
import appSettings from "./appSettings";

export default {
  currentUser,
  roles,
  appSettings,
};
